import React from "react";
import { useNavigate } from "react-router-dom";


function Cta() {
    const navigate = useNavigate();

    return (
        <section className="cta">
            <div className="cta-text-container">
                <div className="cta-title">
                    Ready to transform your business?
                </div>

                <div className="cta-text">
                    From managing finances to streamlining sales and tracking inventory, our technology is designed to make running your business easier and more efficient. Sign up for a Demo today and experience the power of our smart ERP software.
                </div>
            </div>
            
            <div className="cta-button">
                <button className="btn btn-outline-primary" onClick={() => navigate("/contact")}>Request Demo</button>
            </div>
        </section>

    ) 
}
    
export default Cta